import { useI18n } from '@cascade/react/i18n';
import { Link, Text } from '@cascade/ui-library';
import clsx from 'clsx';
import classes from './Footer.module.scss';
import type { TFooterProps } from './Footer.types.ts';
import { PRIVACY_POLICY_URL, TERMS_OF_SERVICE_URL } from '#config/index.ts';

const COPYRIGHT_YEAR = new Date().getFullYear();

export const Footer = ({ className }: TFooterProps) => {
  const { translate } = useI18n();

  return (
    <footer className={clsx(classes.footer, className)}>
      <Link
        label={translate('legal.privacy')}
        uri={PRIVACY_POLICY_URL}
        variant='secondary'
        textProps={{ type: 'caption' }}
      />
      <Link
        label={translate('legal.terms')}
        uri={TERMS_OF_SERVICE_URL}
        variant='secondary'
        textProps={{ type: 'caption' }}
      />
      <Text
        type='caption'
        color='text-60'
        inline
        content={translate('legal.copyright', { year: COPYRIGHT_YEAR })}
      />
    </footer>
  );
};
